// Bundle entry — built to a single minified IIFE as dist/mdfs.v1.js.
// Everything lives in ./core so the same code is unit-testable without the
// module's load-time side effect getting in the way.
import { start } from './core';

start();
